import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/contexts/AuthContext";
import { t } from "@/lib/i18n";
import { formatApiErrorDetail } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Benvenuto!");
      nav(u.role === "admin" ? "/admin" : "/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <img src="https://images.unsplash.com/photo-1670819917685-f1040e76b9b7" alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-primary/60" />
        <div className="relative z-10 h-full flex flex-col justify-between p-12 text-primary-foreground">
          <Link to="/" className="font-display text-2xl font-black" data-testid="login-brand-link">
            Tavolo<span className="text-[hsl(var(--accent))]">OS</span>
          </Link>
          <blockquote className="font-display text-3xl leading-tight tracking-tight max-w-md">
            "Il sistema più elegante che abbiamo mai usato in sala."
            <div className="mt-4 text-sm opacity-70 font-sans">— Osteria del Borgo, Roma</div>
          </blockquote>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={onSubmit} className="w-full max-w-md space-y-6 fade-up" data-testid="login-form">
          <div>
            <h1 className="font-display text-4xl font-black tracking-tighter">{t.auth.login_title}</h1>
            <p className="mt-2 text-muted-foreground">{t.auth.login_sub}</p>
          </div>
          <div className="space-y-2">
            <Label>{t.auth.email}</Label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email-input" />
          </div>
          <div className="space-y-2">
            <Label>{t.auth.password}</Label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password-input" />
          </div>
          <Button type="submit" className="w-full pill-btn h-11 bg-primary text-primary-foreground hover:bg-[hsl(var(--accent))]" disabled={loading} data-testid="login-submit-btn">
            {loading ? "..." : t.auth.submit_login}
          </Button>
          <div className="text-sm text-muted-foreground text-center">
            {t.auth.no_account} <Link to="/register" className="text-[hsl(var(--accent))] hover:underline" data-testid="login-goto-register">{t.auth.register_link}</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
